import { useGetTreatment } from '@zg-rentals/split';

import SplitTestConstants from '../constants/SplitTestConstants';

import type { SplitExperimentsProps } from '@zg-rentals/split';

export const useConciseModularListing = () => {
  const { data: splitExperiment, isLoading } = useGetTreatment({
    featureName: SplitTestConstants.ZRM_CONCISE_MODULAR_LISTING,
  });

  const splitExperiments: SplitExperimentsProps = splitExperiment
    ? { [SplitTestConstants.ZRM_CONCISE_MODULAR_LISTING]: splitExperiment }
    : {};

  return { splitExperiments, isLoading };
};
